<template lang="pug">
#linha-resumo-alertas
    h3
        i.el-icon-s-flag(:style='`color: ${corIcone};`')
        | {{ textoDias }}

    h3 {{ totalAcumulado }}
</template>

<script>
export default {
    name: 'LinhaResumoAlertas',

    props: {
        corIcone: {
            default: 'var(--gray)',
            type: String
        },
        dias: {
            required: true,
            type: Number
        },
        qtdAlertas: {
            required: true,
            type: Number
        }
    },

    computed: {
        textoDias: function () {
            switch (this.dias) {
                case 1:
                    return '1 dia';

                case 90:
                    return '3 meses';

                default:
                    return `${this.dias} dias`;
            }
        },

        totalAcumulado: function () {
            switch (this.qtdAlertas) {
                case 0:
                    return 'Nenhum';

                case 1:
                    return '1 alerta';

                default:
                    return `${this.qtdAlertas} alertas`;
            }
        }
    }
};
</script>

<style lang="scss">
#linha-resumo-alertas {
    display: flex;
    justify-content: space-around;

    h3 {
        min-width: 100px;
        text-align: left;
    }
}
</style>
